import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        // APP显示状态相关
        primaryDrawer: true,
        fullscreenLoading: false,
        fullscreenImages: null,
        printPageSize: "",
        supportBrowser:0,
        mainContentScrolled: 0,
        fixHeaderHeightInPx: 70,
        printMode: false,
        loading: false,
        loadingThread: 0,
        showSearchPanel: localStorage.getItem("showSearchPanel") == "true",
        showSparklinePanel: localStorage.getItem("showSparklinePanel") == "true",
        // 账号相关
        accessToken: "",
        accountInfo: null,
        accountUser: null,
        allow: null,
        settings: null,
        permission_districts: null,
        permission_stocks: null,
        net_units: [], //净含量可用的单位数组
        // 分组树相关
        serverDistricts: [],
        searchDistrict: true,
        districtID: 0,
        citiesMap: [],
        citiesMapTime: 0,
        // 待办提醒
        unReadNotice: 0,
        cloudPrintPageSize: "",
        subAccountEditStatus: {}
    },
    mutations: {
        LOGIN(state, accessToken) {
            localStorage.setItem("accessToken", accessToken);
            state.accessToken = accessToken;
        },
        USERINFO(state, data) {
            state.accountUser = data.account_user;
            state.accountInfo = data.account_info;
            state.allow = data.allow;
            state.settings = data.settings;
            if (data.settings && data.settings.logo_url) {
                localStorage.setItem("logo_url", data.settings.logo_url);
            } else {
                localStorage.removeItem("logo_url");
            }
            state.permission_districts = data.permission_districts;
            state.permission_stocks = data.permission_stocks;
        },
        NET_UNITS(state, data) {
            state.net_units = data;
        },
        LOGOUT(state) {
            state.accessToken = "";
            localStorage.setItem("accessToken", "");
            //清理会话存储
            sessionStorage.clear();
            //清理账号相关的状态
            state.accountInfo = null;
            state.accountUser = null;
            state.allow = null;
            state.searchDistrict = false;
            state.districtID = 0;
            //重新加载页面
            var url = window.location.href;
            var arrUrl = url.split("//");
            var start = arrUrl[1].indexOf("/");
            window.open(arrUrl[0] + "//" + arrUrl[1].substring(0, start), "_self");
        },
        mainContentScrolled(state, top) {
            state.mainContentScrolled = top;
        },
        fixHeaderHeightInPx(state, height) {
            state.fixHeaderHeightInPx = height;
        },
        fullscreenLoading(state, loading) {
            state.fullscreenLoading = loading;
        },
        printPageSize(state, printPageSize){
            state.printPageSize = printPageSize;
        },
        supportBrowser(state, supportBrowser){
            state.supportBrowser = supportBrowser;
        },
        printMode(state, printMode) {
            state.printMode = printMode;
        },
        cloudPrintPageSize(state, cloudPrintPageSize) {
            state.cloudPrintPageSize = cloudPrintPageSize;
        },
        primaryDrawer(state, open) {
            state.primaryDrawer = open;
        },
        fullscreenImages(state, imgs) {
            state.fullscreenImages = imgs;
        },
        threadLoading(state, loading) {
            if (loading) {
                state.loadingThread++;
                state.loading = true;
            } else {
                state.loadingThread--;
                if (state.loadingThread <= 0) {
                    state.loadingThread = 0;
                    state.loading = false;
                }
            }
        },
        threadLoadingStopAll(state) {
            state.loadingThread = 0;
            state.loading = false;
        },
        serverDistricts(state, serverDistricts) {
            state.serverDistricts = serverDistricts;
        },
        searchDistrict(state, show) {
            state.searchDistrict = show;
        },
        districtID(state, districtID) {
            state.districtID = districtID;
        },
        toggleSearchPanel(state) {
            state.showSearchPanel = !state.showSearchPanel;
            localStorage.setItem("showSearchPanel", state.showSearchPanel);
        },
        openSearchPanel(state) {
            state.showSearchPanel = true;
            localStorage.setItem("showSearchPanel", state.showSearchPanel);
        },
        closeSearchPanel(state) {
            state.showSearchPanel = false;
            localStorage.setItem("showSearchPanel", state.showSearchPanel);
        },
        toggleSparkline(state) {
            state.showSparklinePanel = !state.showSparklinePanel;
            localStorage.setItem("showSparklinePanel", state.showSparklinePanel);
        },
        citiesMap(state, citiesMap) {
            state.citiesMap = citiesMap;
            state.citiesMapTime = new Date().getTime();
        },
        unReadNotice(state, count) {
            state.unReadNotice = count;
        },
        subAccountEditStatus(state, subAccountEditStatus) {
            state.subAccountEditStatus = subAccountEditStatus;
        },
        
    },
    getters: {
        panels: state => {
            return [
                state.showSearchPanel ? 0 : null,
                state.showSparklinePanel ? 1 : null
            ]
        },
        supplierId: state => {
            return state.accountUser ? state.accountUser.supplier_id : 0
        }
    },
    actions: {
        fullscreenLoading(context) {
            context.commit('fullscreenLoading', true);
        },
        fullscreenLoadingStop(context) {
            context.commit('fullscreenLoading', false);
        },
        threadLoadingStart(context) {
            context.commit('threadLoading', true);
        },
        threadLoadingStop(context) {
            context.commit('threadLoading', false);
        },
        threadLoadingStopAll(context) {
            context.commit('threadLoadingStopAll');
        },
    }
})

export default store;